import { api } from './client';

/** ч.1018, SPEC 8.3: аналітика підтримки. */
export interface AnalyticsTotals {
  cases_total: number;
  cases_open: number;
  cases_unassigned: number;
  agent_answers: number;
  agent_escalations: number;
  /** ТЕХНІЧНА успішність завдань, НЕ задоволеність користувача. */
  agent_success: number;
  agent_failed: number;
  avg_first_reply_minutes: number | null;
  help_gaps: number;
  help_searches: number;
  help_searches_empty: number;
  articles_helpful: number;
  articles_not_helpful: number;
  consulting_requests: number;
}

export interface Analytics {
  period_days: number;
  generated_at: string;
  totals: AnalyticsTotals;
  top_routes: { route_pattern: string | null; cases: number; has_article: boolean }[];
  consulting_topics: { topic: string; count: number }[];
  empty_searches: { query: string; count: number }[];
  top_articles: { slug: string; title: string; views: number;
                  helpful: number; not_helpful: number }[];
  repeated: { title: string; count: number; public_ids: string[] }[];
}

export interface EvalDetail {
  code: string;
  title: string;
  kind: string;
  passed: boolean;
  critical: boolean;
  got: string;
}

export interface EvalRun {
  run_id: string;
  total: number;
  passed: number;
  failed: number;
  critical_failed: number;
  details: EvalDetail[];
}

export const supportAnalytics = {
  /** ч.1020: контроль якості агента. Безкоштовно, без виклику моделі. */
  runEvals: () =>
    api.post<EvalRun>('/support-analytics/evals/run').then((r) => r.data),

  lastEval: () =>
    api.get<EvalRun | null>('/support-analytics/evals/last').then((r) => r.data),

  get: (days: number) =>
    api.get<Analytics>('/support-analytics', { params: { days } })
      .then((r) => r.data),
};

export default supportAnalytics;
